import { CommonModule } from '@angular/common';
import { AfterViewChecked, ChangeDetectorRef, Component, Inject, NgZone, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, GoogleTagManagerService, ToastmessageService } from '@prekog/common-ui';
import { Speciality } from '../consultation/speciality';
import { Doctor } from '../doctor';
import { GetDoctorsByRequest } from './getdoctorsbyrequest';
import { GetDoctorsByResponse } from './getdoctorsbyresponse';
import { GetSpecialityDescriptionRequest } from './getspecialitydescriptionrequest';
import { GetSpecialityDescriptionResponse } from './getspecialitydescriptionresponse';

@Component({
    selector: 'app-specialitydescription',
    templateUrl: './specialitydescription.component.html',
    styleUrls: ['./specialitydescription.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class SpecialitydescriptionComponent implements OnInit, AfterViewChecked {
    doctorList: Doctor[] = [];
    event = 'Szakrendelés megtekintése';
    getDoctorsBySpecialityUrl = '/regenero/get-doctors-by-speciality';
    getSpecialityByRouterLinkUrl = '/regenero/get-speciality-by-routerLink';

    regeneroBaseUrl = '';

    routerLink = '';
    speciality: Speciality = {};

    constructor(
        public _router: Router,
        private ref: ChangeDetectorRef,
        private ngZone: NgZone,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService,
        private readonly _domSanitizer: DomSanitizer,
        private _googleTagManagerService: GoogleTagManagerService
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }

    ngAfterViewChecked(): void {
        this.ngZone.runOutsideAngular(() => {
            this.ref.detectChanges();
            setTimeout(() => {
                const lastSegmentOfUrl = window.location.href.split('/').pop();
                const routerLink = lastSegmentOfUrl as string;
                if (this.routerLink != routerLink) {
                    window.location.reload();
                }
            }, 0);
        });
    }

    ngOnInit(): void {
        const fullUrl = window.location.href;
        const routerLink = fullUrl.split('/').pop()?.split('?')[0] || '';
        this.routerLink = routerLink;

        const getSpecialityDescriptionRequest: GetSpecialityDescriptionRequest = {
            routerLink: routerLink
        };

        this._apiRequestService
            .sendRequest<
                GetSpecialityDescriptionRequest,
                GetSpecialityDescriptionResponse
            >(this.regeneroBaseUrl, getSpecialityDescriptionRequest, true, this.getSpecialityByRouterLinkUrl)
            .subscribe((response) => {
                this.speciality = response.speciality!;
                this.getDoctors(this.speciality.id!);
                this.speciality.description = this._domSanitizer.bypassSecurityTrustHtml(this.speciality.description!) as string;
                this.ngZone.runOutsideAngular(() => {
                    setTimeout(() => {
                        this._googleTagManagerService.viewCustomObject(this.event, this.speciality.name!);
                    }, 0);
                });
            });
    }

    getDoctors(specialityId: number) {
        const getdoctorsbyrequest = {
            specialityId: specialityId
        };
        this._apiRequestService
            .sendRequest<
                GetDoctorsByRequest,
                GetDoctorsByResponse
            >(this.regeneroBaseUrl, getdoctorsbyrequest, true, this.getDoctorsBySpecialityUrl)
            .subscribe((response) => {
                this.doctorList = response.doctorList!;
            });
    }

}
